const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/settings.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/dashboard/settings')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});